import { Button } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function AccessDenied() {
  const navigate = useNavigate();
  const handleClick = () => {
    navigate('/vendors')
  }

  return (
    <div style={styles.body}>
      <div style={styles.lock}>
        <div style={styles.lockBefore}></div>
        <div style={styles.lockAfter}></div>
      </div>
      <div style={styles.message}>
        <h1 style={styles.heading}>Access to this page is restricted</h1>
        <Button
          variant="contained"
          sx={{
            backgroundColor: '#808080', // Gri renk
            color: '#fff', // Yazı rengi (beyaz)
            '&:hover': {
              backgroundColor: '#696969', // Daha koyu gri renk (hover durumunda)
            },
          }}
          onClick={handleClick}
        >
          Go to Back
        </Button>


      </div>
    </div>
  );
}

const animationTime = '2s';

const styles = {
  body: {
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    background: 'linear-gradient(to bottom right, #eee, #aaa)',
    fontFamily: "'Lato', sans-serif",
  },
  heading: {
    margin: '40px 0 20px',
  },
  lock: {
    borderRadius: '5px',
    width: '55px',
    height: '45px',
    backgroundColor: '#333',
    animation: `dip 1s`,
    position: 'relative',
  },
  lockBefore: {
    position: 'absolute',
    borderLeft: '5px solid #333',
    height: '30px',
    width: '15px',
    left: 'calc(50% - 12.5px)',
    top: '-30px',
    border: '5px solid #333',
    borderBottomColor: 'transparent',
    borderRadius: '15px 15px 0 0',
    animation: `lock ${animationTime}, spin ${animationTime}`,
  },
  lockAfter: {
    position: 'absolute',
    borderLeft: '5px solid #333',
    height: '20px',
    width: '15px',
    left: 'calc(50% - 12.5px)',
    top: '-10px',
    borderRight: '5px solid transparent',
    animation: `spin ${animationTime}`,
  },
  message: {
    textAlign: 'center',
  },

};
